import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Alert, Button, Grid, Link, Paper, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import React from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateAlabama = (): React.JSX.Element => {
  const [open, setOpen] = React.useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Arizona Business Tax filing Requirements | TaxZerone"
          description="Understand Arizona business tax requirements with TaxZerone — get clear guidance to meet deadlines, stay compliant, and avoid penalties."
          keywords=" "
          canonical="business-tax/state-filing/arizona-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/arizona-business-tax-img.webp" />
                <source srcSet="/assets/images/arizona-business-tax-img.png" />
                <img
                  src="/assets/images/arizona-business-tax-img.png"
                  alt="Arizona Business Tax Requirements — Everything You Need to Know"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Arizona </span>
                </span>{' '}
                Business Tax Filing Requirements — Everything You Need to Know
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Understand your Arizona business filing needs — from corporate
                income tax to TPT and employer withholdings, stay compliant and
                avoid costly penalties.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/arizona-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/arizona-business-tax-img-sm.png" />
                <img
                  src="/assets/images/arizona-business-tax-img-sm.png"
                  alt="Arizona Business Tax Requirements — Everything You Need to Know"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in Arizona?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            Arizona requires different business entities to file specific state
            tax forms with the{' '}
            <span style={{ fontWeight: 600 }}>
              {' '}
              Arizona Department of Revenue (ADOR).
            </span>
            .
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            Here’s a breakdown by business type:
          </Typography>
          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br />
                    Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/document/FORMS_INDIVIDUAL_2024_140_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 140
                        </Link>{' '}
                        –
                      </span>{' '}
                      Arizona Individual Income Tax Return{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-prior/f1040sc--2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Federal Schedule C
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Profit or Loss from Business{' '}
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_INDIVIDUAL_2021_140SCHA_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 140 Schedule A
                        </Link>{' '}
                        (if applicable) -
                      </span>{' '}
                      Itemized Deductions{' '}
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_PARTNERSHIP_2021_165_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 165
                        </Link>{' '}
                        –
                      </span>{' '}
                      Partnership Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1065sk1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Schedule K-1
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Partner’s Share of Income, Deductions, and Credits
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-12/FORMS_CORPORATE_2023_120_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 120
                        </Link>{' '}
                        –
                      </span>
                      Arizona Corporation Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_CORPORATE_2021_120A_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 120A
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Short Form Corporation Income Tax Return (for qualifying
                      corporations)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="S Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.revenue.alabama.gov/wp-content/uploads/2023/01/22f20s.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 120S
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Income Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Transaction Privilege Tax (All Applicable Businesses) "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Transaction Privilege Tax (All Applicable Businesses)
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_TPT_2016_10872-f_0201.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form TPT-1
                        </Link>{' '}
                        –
                      </span>{' '}
                      Transaction Privilege Tax License Application
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_TPT_11249.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form TPT-2
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Transaction Privilege, Use, and Severance Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/withholding-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/withholding-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/withholding-tax-icon.png"
                    alt="Employer Withholding Tax"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Employer Withholding Tax
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_WITHHOLDING_A1-QRT_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form A1-QRT
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Quarterly Withholding Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-07/FORMS_WITHHOLDING_2022_A1-R_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form A1-R
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Annual Reconciliation of Arizona Income Tax Withheld
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-12/FORMS_WITHHOLDING_2023_A1-APR.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form A1-APR
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Arizona Annual Payment Withholding Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Business Personal Property Tax"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Business Personal Property Tax
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_PROPERTY_82520I-List.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 82520
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Business Personal Property Statement
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/other-form-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/other-form-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/other-form-icon.png"
                    alt="Other Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Other Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_POA_10952-f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 285
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Power of Attorney (POA) / Disclosure
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_TPT_10193_f.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 10193
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Business Account Update
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 5 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the Deadlines for Business Tax Forms in Arizona?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Understand the key deadlines for filing Arizona business taxes
                for all entity types
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                C Corporations
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="strong"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15th day
                </Box>
                <br />
                of 4<sup>th</sup> month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(213, 189, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Stack
                spacing={2}
                direction={{ md: 'column', xs: 'column' }}
                justifyContent="center"
              >
                <Box
                  component="ul"
                  sx={{
                    mb: 0,
                    width: '100%',
                    '& li': { mb: 1.5, fontWeight: 600 },
                    textAlign: 'left',
                    listStyleType: 'none',
                  }}
                >
                  <li>
                    {' '}
                    <VerifiedIcon sx={{ mb: -0.6, mr: 1, color: '#d60aff' }} />S
                    Corporations{' '}
                  </li>
                  <li>
                    {' '}
                    <VerifiedIcon sx={{ mb: -0.6, mr: 1, color: '#d60aff' }} />
                    Partnerships{' '}
                  </li>
                </Box>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 18, md: 16, sm: 14, xs: 14 },
                        fontWeight: 500,
                      }}
                    >
                      Return due date:{' '}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                      }}
                    >
                      <Box
                        component="strong"
                        sx={{
                          background:
                            'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                          backgroundClip: 'text',
                          color: 'transparent',
                          fontWeight: 700,
                          fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                        }}
                      >
                        15<sup>th</sup> day
                      </Box>{' '}
                      <br />
                      of 3<sup>rd</sup> month
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Transaction Privilege Tax
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="strong"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  20<sup>th</sup> day
                </Box>
                <br />
                of the month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Employer Withholding Tax
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                  mb: 1,
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                component="ul"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  '& li': { mb: 1.5, textAlign: 'left' },
                }}
              >
                <li>
                  {' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Quarterly Return (Form A1-QRT):
                  </span>{' '}
                  last day of the month{' '}
                </li>
                <li>
                  {' '}
                  <span style={{ fontWeight: 600 }}>
                    Annual Reconciliation (Form A1-R):
                  </span>{' '}
                  January 31
                </li>
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Business Personal Property Tax
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  April 1
                </Box>
                <br />
                of each year (Filed with your County Assessor’s Office)
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What are the Business Extension Forms are required in Arizona?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Business Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Corporation & S Corporation
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Partnerships & Multi-Member LLCs
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Individuals, Sole Proprietors & Single-Member LLCs
                    </Box>{' '}
                  </li>
                </Box>
                <Box
                  sx={{
                    maxWidth: 350,
                    mb: 3,
                    p: 2,
                    border: '5px solid transparent',
                    borderRadius: 3,
                    background:
                      'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 700, mb: 0.8 }}>
                    {' '}
                    <MailOutlineOutlinedIcon
                      sx={{
                        position: 'relative',
                        ml: 0,
                        mr: 0.5,
                        mb: -1,
                        fontSize: 28,
                      }}
                    />{' '}
                    Mail Form 120EXT or Form 204 to:
                  </Typography>
                  <Box
                    component="div"
                    sx={{ textAlign: 'left', fontSize: '15px important' }}
                  >
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Arizona Department of Revenue
                      </span>{' '}
                      <br />
                      PO Box 29085 <br />
                      Phoenix, AZ 85038-9085
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/arizona-extension-img.webp" />
                  <source srcSet="/assets/images/arizona-extension-img.png" />
                  <img
                    src="/assets/images/arizona-extension-img.png"
                    alt="What are the Business Extension Forms are required in Arizona?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
            <Grid size={12} sx={{ textAlign: 'center' }}>
              <Typography variant="body1">
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Arizona business tax payments
                </span>{' '}
                can also be made electronically through:{' '}
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                <Link
                  href="https://www.aztaxes.gov/Home/Page"
                  target="_blank"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  AZTaxes.gov
                </Link>{' '}
                – the official online portal for filing and payments.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due dates for Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Forms in Arizona?
              </Typography>
              <Box sx={{ maxWidth: 750, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        7- month
                      </Box>
                      <br />
                      of automatic extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        6-month
                      </Box>{' '}
                      <br />
                      of automatic extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Partnerships
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        6- month
                      </Box>{' '}
                      <br />
                      of automatic extension
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Transaction Privilege Tax
                    </Typography>
                    <Typography variant="body1">No formal extension</Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Employer Withholding Tax
                    </Typography>
                    <Typography variant="body1">No formal extension</Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Business Personal Property Tax
                    </Typography>
                    <Typography variant="body1">Varies by country </Typography>
                  </Paper>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Arizona Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in Arizona, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          File or pay by the original due date
                        </span>{' '}
                        to avoid late filing and payment penalties.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Submit the correct extension form
                        </span>{' '}
                        based on your business entity type (Form{' '}
                        <span style={{ fontWeight: 600 }}>120 / 165EXT,</span>{' '}
                        Form <span style={{ fontWeight: 600 }}>204</span>).
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Estimate and pay any taxes owed —
                        </span>{' '}
                        extensions apply only to filing, not to payments.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Meet the 6-month filing extension period,
                        </span>{' '}
                        typically extending your deadline from the original due
                        date.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Keep confirmation and payment records
                        </span>{' '}
                        from the{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Arizona Department of Revenue (ADOR)
                        </span>{' '}
                        for compliance purposes.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{}}>
                  <picture>
                    <source
                      srcSet="/assets/images/arizona-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/arizona-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/arizona-state-img.png"
                      loading="lazy"
                      alt="business tax extension in Arizona"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                    }}
                  >
                    Arizona Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 3,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates in Arizona vary based on your entity
                    type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporation{' '}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    4.9%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of Arizona taxable income (flat corporate income tax rate
                    effective from 2023).
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Pass Through Entity
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Generally, not subject to corporate income tax; income
                    passes through to shareholders and is taxed on their
                    individual returns.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Partnerships & LLCs
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Pass Through Entity
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Not taxed at the entity level. Members report income on
                    their individual or corporate tax returns.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Transaction Privilege Tax
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{ fontSize: 18, fontWeight: 600 }}
                  >
                    Varies by business activity and location
                  </Typography>
                  <Typography variant="body1">
                    State base rate:{' '}
                    <span style={{ fontWeight: 600 }}> 5.6%,</span> plus
                    applicable{' '}
                    <span style={{ fontWeight: 600 }}>
                      city and county rates
                    </span>
                    .
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                    justifyContent: 'center',
                    alignContent: 'center',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Employer Withholding Tax
                  </Typography>

                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    <span style={{ fontWeight: 600 }}> Rates vary</span> based
                    on employee income and Arizona withholding tables provided
                    by ADOR.
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Financial Institution
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    4.9%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of net income earned in Arizona (same as the corporate
                    income tax rate).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated Tax Payments for Arizona Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 19, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses in Arizona must make{' '}
                  <span style={{ fontWeight: 600 }}>
                    estimated tax payments
                  </span>{' '}
                  if they expect to owe{' '}
                  <span style={{ fontWeight: 600 }}>$1,000 or more</span> in{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  state income tax for the year. These prepayments help avoid{' '}
                  <span style={{ fontWeight: 600 }}>
                    underpayment penalties and interest.
                  </span>
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      April 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      June 15
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Sept 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Dec 15
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Corporations & Financial Institutions
                    </Typography>
                    <Typography variant="body1">
                      If Arizona tax liability is expected to be{' '}
                      <span style={{ fontWeight: 600 }}>$1,000 or more,</span>
                      use <span style={{ fontWeight: 600 }}>Form 120W</span> for
                      estimated payments.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      S Corporations (PTE Election)
                    </Typography>
                    <Typography variant="body1">
                      If the business elects to pay tax at the entity level and
                      expects to owe{' '}
                      <span style={{ fontWeight: 600 }}> over $500,</span> use{' '}
                      <span style={{ fontWeight: 600 }}>Form 120ES.</span>
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Partnerships (PTE Election)
                    </Typography>
                    <Typography variant="body1">
                      Partnerships making the PTE election must pay estimated
                      taxes using{' '}
                      <span style={{ fontWeight: 600 }}>Form 165ES.</span>
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      LLCs
                    </Typography>
                    <Typography variant="body1">
                      LLCs follow the rules of their tax classification (C Corp,
                      S Corp, or Partnership)
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Late or missed estimated payments may result in{' '}
                  <span style={{ fontWeight: 600 }}>
                    interest charges and penalties
                  </span>{' '}
                  from the
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Arizona Department of Revenue (ADOR).
                  </span>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Business in Arizona
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                If your business doesn’t pay the required tax by the original
                due date,
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  penalties and interest may apply
                </span>
                —even if you’ve filed an extension.
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 2 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Payment Penalty
                    </Typography>
                    <Typography variant="body1">
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        0.5% of the unpaid tax{' '}
                      </span>{' '}
                      for each month (or part of a month) the payment is late,
                      up to a{' '}
                      <span style={{ fontWeight: 600 }}> maximum of 10%.</span>
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: { lg: '43%', md: '41%', sm: '40%' },
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Filing Penalty
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2 }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        4.5% of the unpaid tax
                      </span>{' '}
                      per month (or part of a month) past due, up to a{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        maximum of 25%
                      </span>{' '}
                      of the unpaid amount.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Interest
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ listStyleType: 'disc', mb: 0, '& > li': { mb: 1 } }}
                    >
                      <li>
                        Charged{' '}
                        <span style={{ fontWeight: 600 }}>
                          daily on any unpaid balance
                        </span>{' '}
                        from the original due date until fully paid.
                      </li>
                      <li>
                        Interest rate:{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          federal short-term rate plus 3%,
                        </span>{' '}
                        adjusted annually.
                      </li>
                    </Box>
                  </Paper>
                </Box>
              </Stack>
              <Alert
                severity="info"
                icon={false}
                sx={{ mb: 3, borderLeft: '3px solid #0288d1' }}
              >
                <b>Tips:</b> Filing your extension and making a timely payment
                through TaxZerone helps you{' '}
                <span style={{ fontWeight: 600 }}>
                  avoid costly penalties and interest
                </span>{' '}
                in Arizona.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone Can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone Can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  TaxZerone helps you with federal filing and guides you in
                  meeting all your state tax requirements, ensuring compliance
                  and minimizing the risk of penalties and interest.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Stay Compliant with Arizona Business Tax Requirements!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Let TaxZerone guide you through{' '}
          <span style={{ fontWeight: 600 }}>
            all federal and Arizona state business tax filings,
          </span>{' '}
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          ensuring you meet deadlines, calculate payments correctly, and avoid
          penalties.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=arizona`}
          >
            Start Filing Now
          </Button>
        </Box>
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What business taxes do I need to pay in Arizona?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1">
                      Arizona businesses may be subject to:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Corporate Income Tax
                        </span>{' '}
                        (C corporations)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          S Corporation / Pass-Through Entity Tax
                        </span>{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Partnership / LLC Income Tax
                        </span>{' '}
                        (if elected PTE)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Transaction Privilege Tax (TPT){' '}
                        </span>{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Employer Withholding Tax
                        </span>{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Business Personal Property Tax
                        </span>{' '}
                      </li>
                      <li>
                        The taxes applicable depend on your{' '}
                        <span style={{ fontWeight: 600 }}>
                          business entity type and operations.
                        </span>
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Does Arizona automatically grant extensions for businesses?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Yes. Most Arizona business entities (corporations, S
                      corporations, partnerships) can receive an{' '}
                      <span style={{ fontWeight: 600 }}>
                        automatic 6-month extension
                      </span>{' '}
                      to file their income tax returns. However, any{' '}
                      <span style={{ fontWeight: 600 }}>
                        tax owed must still be paid by the original due date
                      </span>{' '}
                      to avoid penalties and interest.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How do I get an extension of time to file in Arizona?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1.5 }}>
                      To obtain an extension, file the{' '}
                      <span style={{ fontWeight: 600 }}>
                        appropriate Arizona extension form
                      </span>{' '}
                      based on your entity type:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          C Corporations & S Corporations:
                        </span>{' '}
                        Form 120/165EXT{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Partnerships & Multi-Member LLCs:
                        </span>{' '}
                        Form 120/165EXT{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Sole Proprietors & Single-Member LLCs:
                        </span>{' '}
                        Form 204{' '}
                      </li>
                    </Box>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                    >
                      <b>Remember: </b> The extension applies to filing only,
                      <span style={{ fontWeight: 600 }}> not payment.</span> Any
                      estimated taxes must be paid by the original due date to
                      avoid penalties.
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What happens if I don’t pay my taxes by the original due
                  date in Arizona?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      If taxes are not paid on time, your business may incur
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        penalties and interest.
                      </span>{' '}
                      Penalties can apply for both{' '}
                      <span style={{ fontWeight: 600 }}>
                        late payments and late filings,
                      </span>{' '}
                      and interest is charged on any unpaid balance until the
                      taxes are fully paid
                    </Typography>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                    >
                      <b>Note: </b> To avoid these extra charges, it’s important
                      to{' '}
                      <span style={{ fontWeight: 600 }}>
                        pay any taxes or estimated payments by the original due
                        date,
                      </span>{' '}
                      even if you file your return later.
                    </Alert>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateAlabama;
